// extracted by mini-css-extract-plugin
export default {"content":"lQUxz1CMuO5Q884uVsns","text":"Awqe2OvxXMIkMoSGgi5n","restoreNotice":"SzS2u6uvi1dsFdcN3wjl","buttonHolder":"zxUrygCvD4BWpZmT94S1"};